<template>
    <header class="container-fluid p-0 position-fixed shadow-header" style="z-index: 101;">
        <div class="d-flex align-items-center justify-content-between p-3">
            <a class="d-flex align-items-center" @click="navigateToHome" style="cursor: pointer;">
                <img :src="logo" alt="Logo" class="logo">   
            </a>
        
            <div class="d-flex align-items-center justify-content-end mx-3">
                <a class="text-primary text-decoration-none mx-2 d-flex align-items-center d-none d-lg-block description-xs epilogue-bold" 
                @click="navigateToNosotros" style="cursor: pointer;">
                    <img :src="chat" class="icon"> Nosotros
                </a>
                <a class="text-primary text-decoration-none mx-2 d-flex align-items-center d-none d-lg-block description-xs epilogue-bold" 
                @click="navigateToTalleres" style="cursor: pointer;">
                    <img :src="hs" class="icon"> Talleres/Expo
                </a>
                <a class="text-primary text-decoration-none mx-2 d-flex align-items-center d-none d-lg-block description-xs epilogue-bold" 
                @click="navigateToEventos" style="cursor: pointer;">
                    <img :src="hh" class="icon"> Eventos
                </a>
                <a class="text-primary text-decoration-none mx-2 d-flex align-items-center d-none d-lg-block description-xs epilogue-bold" 
                @click="navigateToBlog" style="cursor: pointer;">
                    <img :src="paper" class="icon"> Blog
                </a>
                <a class="text-primary text-decoration-none mx-2 d-flex align-items-center d-lg-none d-block description-xs epilogue-bold" 
                @click="showModal = true" style="cursor: pointer;">
                    <img :src="burguer" class="icon">
                </a>
            </div>
        </div>
            <div class="modalmn d-lg-none" v-show="showModal">
                <div class="modal-content">
                    <div class="d-flex align-items-center justify-content-center flex-column">
                        <a class="text-decoration-none text-primary text-decoration-none mx-2 d-flex align-items-center description-md epilogue-bold m-2"
                        @click="navigateToNosotros" style="cursor: pointer;">
                            <img src="../assets/icons/chat.svg" class="icon"> Nosotros
                        </a>
                        <a class="text-decoration-none text-primary text-decoration-none mx-2 d-flex align-items-center description-md epilogue-bold m-2"
                        @click="navigateToTalleres" style="cursor: pointer;">
                            <img src="../assets/icons/headsets.svg" class="icon"> Talleres/Expo
                        </a>
                        <a class="text-decoration-none text-primary text-decoration-none mx-2 d-flex align-items-center description-md epilogue-bold m-2"
                        @click="navigateToEventos" style="cursor: pointer;">
                            <img src="../assets/icons/handsHeart.svg" class="icon"> Eventos
                        </a>
                        <a class="text-decoration-none text-primary text-decoration-none mx-2 d-flex align-items-center description-md epilogue-bold m-2"
                        @click="navigateToBlog" style="cursor: pointer;">
                            <img src="../assets/icons/paper.svg" class="icon"> Blog
                        </a>
                    </div>
                    <a class="text-center ms-2" @click="showModal = !showModal" style="cursor: pointer;">
                        <img :src="x" class="img-fluid m-3 imghover position-absolute top-0 end-0" style="max-height: 60px;" width="60" height="60" alt="cerrar" loading="lazy">
                    </a>
                </div>
            </div>
    </header>
</template>

<script setup>
    import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
    import { useRouter } from 'vue-router'
    import { useStore } from "vuex"

    import burguer from "ASSETS/icons/navbar"
    import x from "ASSETS/icons/x"
    import logo from "ASSETS/icons/logo"
    import chat from "ASSETS/icons/chat"
    import hs from "ASSETS/icons/headsets"
    import hh from "ASSETS/icons/handsHeart"
    import paper from "ASSETS/icons/paper"




    const router = useRouter()

    const showModal = ref(false);
    const navigateToHome = () => {
      router.push("/");
      window.scrollTo(0, 0);
      showModal.value = false;
    };

    const navigateToNosotros = () => {
      router.push("/nosotros");
      window.scrollTo(0, 0);
      showModal.value = false;
    };
    const navigateToTalleres = () => {
      router.push("/talleres");
      window.scrollTo(0, 0);
      showModal.value = false;
    };
    const navigateToEventos = () => {
      router.push("/eventos");
      window.scrollTo(0, 0);
      showModal.value = false;
    };
    const navigateToBlog = () => {
      router.push("/blog");
      window.scrollTo(0, 0);
      showModal.value = false;
    };
    

</script>

<style lang="scss" scoped>
    .modalmn {
        display: flex;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.336); 
        z-index: 102;
    }
    .modal-content {
        max-width: 90%;
        height: auto;
        position: absolute;
        top: 210px;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: #ffffffee; 
        padding: 10px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.014);
        border-radius: 30px;
    }
    .shadow-header {
        
        background: #ffffff;
        box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.2);
        width: calc(100% - 40px); // Descuento del padding del body
        top: 20px;
        left: 20px;
        border-radius: 100px;

    }


    .style-btn {
        border-radius: 100px;
        color: #207CEB;
    }

    .icon {
        margin-right: 10px;
    }

    .logo {
        width: 40px;
        height: 40px;
    }


    @media (max-width: 768px) {
        .shadow-header {
            padding: 10px 20px; 
        }

        .style-btn, .text-primary {
            font-size: 12px; 
        }

        .logo {
            width: 30px; 
            height: 30px;
        }
    }

    @media (min-width: 769px) {
        .shadow-header {
            padding: 15px 30px; 
        }
    }
</style>
